query MobileSdkTestIssues(
	$testId: ConditionID!
	$offset: Int
	$limit: Int
	$sort: issuesSort
	$textSearch: issuesSearchInsensitive
	$severityIdFilter: ConditionString
	$typeIdFilter: ConditionString
	$scanNameFilter: ConditionString
) {
	issues(
		run_id_eq: $testId
		offset: $offset
		limit: $limit
		sort: $sort
		severity_name_eq: $severityIdFilter
		type_name_eq: $typeIdFilter
		scan_name_eq: $scanNameFilter
		text_contains: $textSearch
		deleted_eq: { value: false }
	) {
		issue_id
		severity_name
		type_name
		scan_name
		run_time
		screenshot
		viewport_width
		viewport_height
		elements__accessibility_identifier
		elements__accessibility_label
		elements__element_type
		elements__view_id
		elements__content_description
		elements__class_name
		elements__bounding_box_x
		elements__bounding_box_y
		elements__bounding_box_width
		elements__bounding_box_height
		elements__id
		elements__index
		elements__component_id
	}

	total: issues(
		run_id_eq: $testId
		severity_name_eq: $severityIdFilter
		type_name_eq: $typeIdFilter
		scan_name_eq: $scanNameFilter
		text_contains: $textSearch
		deleted_eq: { value: false }
	) {
		issue_id_count
	}

	unfiltered_total: issues(run_id_eq: $testId, deleted_eq: { value: false }) {
		issue_id_count
	}
}
